import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Feature flag: REACT_APP_USE_V2=true (production) uses the V2 architecture.
// The legacy monolith (App.js) is only loaded when the flag is off, so it stays
// out of the production bundle.
const useV2 = process.env.REACT_APP_USE_V2 === 'true';
const RootApp = useV2 ? lazy(() => import('./AppV2')) : lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{ padding: 24, fontFamily: 'sans-serif' }}>Loading FieldSync…</div>}>
      <RootApp />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
